import { studio } from "@/lib/studioApi";

const KEY = "devisto_offline_queue";

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) { return []; }
};
const write = (queue) => localStorage.setItem(KEY, JSON.stringify(queue));
const uid = () => `local-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const readQueue = read;
export const isOffline = () => typeof navigator !== "undefined" && !navigator.onLine;

export const pendingCount = () =>
  read().reduce((n, item) => n + 1 + (item.children?.length || 0), 0);

// Brouillon de dossier créé sans réseau
export const queueDossier = (payload) => {
  const queue = read();
  const draft = { kind: "dossier", localId: uid(), payload, children: [], created_at: new Date().toISOString() };
  queue.push(draft);
  write(queue);
  return draft;
};

// Note / mesure / matériel ajouté sans réseau (dossier déjà en ligne ou brouillon local)
export const queueChild = (target, field, payload) => {
  const queue = read();
  if (String(target).startsWith("local-")) {
    const draft = queue.find((q) => q.localId === target);
    if (draft) draft.children.push({ field, payload });
  } else {
    queue.push({ kind: "child", localId: uid(), dossierId: target, field, payload, created_at: new Date().toISOString() });
  }
  write(queue);
};

export const removeDraft = (localId) => write(read().filter((q) => q.localId !== localId));

export const localDrafts = () => read().filter((q) => q.kind === "dossier");

let flushing = false;

// Synchronisation : dossiers d'abord, puis leurs éléments (un seul flush à la fois)
export const flushQueue = async () => {
  if (flushing) return { synced: 0, failed: 0 };
  const queue = read();
  if (!queue.length) return { synced: 0, failed: 0 };
  flushing = true;
  write([]); // on réserve la file : évite les doubles envois
  let synced = 0;
  let failed = 0;
  const remaining = [];

  for (const item of queue) {
    try {
      if (item.kind === "dossier") {
        const { data } = await studio.post("/dossiers", item.payload);
        synced += 1;
        for (const child of item.children || []) {
          await studio.post(`/dossiers/${data.id}/${child.field}`, child.payload);
          synced += 1;
        }
      } else {
        await studio.post(`/dossiers/${item.dossierId}/${item.field}`, item.payload);
        synced += 1;
      }
    } catch (e) {
      failed += 1;
      remaining.push(item);
    }
  }
  write([...remaining, ...read()]);
  flushing = false;
  return { synced, failed };
};
